'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * Details summary component, contains a the heading to toggle the content.
 *
 * @example
 * <Details.Summary>Heading</Details.Summary>
 */
const DetailsSummary = forwardRef(function DetailsSummary(rest, ref) {
    return (jsx("summary", { suppressHydrationWarning // Since <details> polyfill adds attributes
        : true, ref: ref, ...rest }));
});

export { DetailsSummary };
